import type { MediaState } from '../types/media-state';

/**
 * 미디어 상태 관리 설정
 */

export const DEFAULT_MEDIA_STATE: MediaState = {
  isMicOn: false,   // 동의 전까지 마이크 OFF
  isSpeakerOn: true, // 스피커는 기본 ON
};

export const MEDIA_CONFIG = {
  // 상태 저장 만료 시간 (ms) - 10분
  STATE_EXPIRATION_TIME: 10 * 60 * 1000,

  // 자동 복원 활성화
  AUTO_RESTORE_ON_MOUNT: false,

  // 디버그 로깅
  ENABLE_LOGGING: true,

  // 마이크 권한 필수 여부
  REQUIRE_MIC_PERMISSION: true,
} as const;

export const MEDIA_LABELS = {
  mic: {
    on: '마이크 켜짐',
    off: '마이크 꺼짐',
  },
  speaker: {
    on: '스피커 켜짐',
    off: '스피커 꺼짐',
  },
} as const;

export const MEDIA_ICONS = {
  mic: {
    on: '🎤',
    off: '🔇',
  },
  speaker: {
    on: '🔊',
    off: '🔈',
  },
} as const;
